import React from "react";
import { CircularProgress as MUICircularProgress } from "@mui/material";
import styled from "styled-components";

const StyledMUICircularProgress = styled(MUICircularProgress)`
  color: var(--primaryColor) !important;
`;

export const CircularProgress = ({ size }) => {
  return <StyledMUICircularProgress size={size} />;
};
